/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */

export type AuthWebappPermissionAtom = typeof AuthWebappPermissionAtom[keyof typeof AuthWebappPermissionAtom];


export const AuthWebappPermissionAtom = {
  'api_key:delete': 'api_key:delete',
  'api_key:read': 'api_key:read',
  'api_key:write': 'api_key:write',
  'bank_account:delete': 'bank_account:delete',
  'bank_account:read': 'bank_account:read',
  'bank_account:write': 'bank_account:write',
  'blockchain_address:delete': 'blockchain_address:delete',
  'blockchain_address:read': 'blockchain_address:read',
  'blockchain_address:write': 'blockchain_address:write',
  'embedded_wallet:write': 'embedded_wallet:write',
  'manage_role:admin': 'manage_role:admin',
  'manage_role:initiator': 'manage_role:initiator',
  'manage_role:owner': 'manage_role:owner',
  'manage_role:view_only': 'manage_role:view_only',
  'manage_role:wallet_account_management': 'manage_role:wallet_account_management',
  'mint:read': 'mint:read',
  'mint:write': 'mint:write',
  'organization:read': 'organization:read',
  'quote:read': 'quote:read',
  'quote:write': 'quote:write',
  'redeem:delete': 'redeem:delete',
  'redeem:read': 'redeem:read',
  'redeem:write': 'redeem:write',
  'reward_addresses:delete': 'reward_addresses:delete',
  'reward_addresses:read': 'reward_addresses:read',
  'reward_addresses:write': 'reward_addresses:write',
  'rewards_rate:read': 'rewards_rate:read',
  'transactions:read': 'transactions:read',
  'users:delete': 'users:delete',
  'users:read': 'users:read',
  'users:write': 'users:write',
  'whitelabel_tokens:delete': 'whitelabel_tokens:delete',
  'whitelabel_tokens:read': 'whitelabel_tokens:read',
  'whitelabel_tokens:write': 'whitelabel_tokens:write',
} as const;
